/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { Text } from '@staffino/primitives';
import { StyledComponent } from '@emotion/styled';
import styled from './styled';
import Paragraph from './paragraph';
import convertCssUnit from './convert-css-unit';

const AnimatedLabel: StyledComponent<React.ComponentProps<typeof Paragraph>> =
  styled(Paragraph)(() => ({
    display: 'inline',
    maxWidth: 'fit-content',
    lineHeight: convertCssUnit('1.375rem'),
    fontSize: convertCssUnit('1.125rem'),
    fontWeight: 'bold',
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
    marginRight: convertCssUnit('0.51rem'),
  }));

const StyledSpan = styled(Text)({
  fontSize: convertCssUnit('1.125rem'),
  color: '#a3b2bf',
  verticalAlign: 'top',
  marginLeft: convertCssUnit('0.125rem'),
});

type Props = {
  label: string;
  showMandatory?: boolean;
} & React.ComponentProps<typeof AnimatedLabel>;

function ControlLabel({ label, showMandatory, ...rest }: Props) {
  if (!label) {
    return null;
  }
  return (
    <AnimatedLabel color="text" {...rest}>
      <Text>{label}</Text>
      {showMandatory && <StyledSpan>*</StyledSpan>}
    </AnimatedLabel>
  );
}

export default ControlLabel;
